import { Navigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import Loading from '@/components/content/loading/Loading';
import ErrorWrapper from '@/components/content/error/ErrorWrapper';

import { openApiFetch } from '@/lib/openapi-fetch';

const finishedPath = '/issue/finished_intel/{resource_id}' as const;
const rawPath = '/issue/raw_intel/{resource_id}' as const;

const CommonIssue = () => {
  const { issue } = useParams();
  const issueId = +(issue as string);

  const baseQuery = (path: typeof finishedPath | typeof rawPath) =>
    useQuery({
      queryKey: [path],
      queryFn: () =>
        openApiFetch(path, {
          params: {
            path: { resource_id: issueId },
          },
        }),
      gcTime: 0,
      staleTime: 0,
    });

  const finishedQuery = baseQuery(finishedPath);
  const rawQuery = baseQuery(rawPath);

  return (
    <ErrorWrapper isError={rawQuery.isError && finishedQuery.isError}>
      <Loading
        text="Loading ticket"
        height="calc(100vh - calc(var(--app-shell-header-offset, 0rem) + var(--app-shell-padding)))"
      />

      {finishedQuery.isSuccess && <Navigate to={`/intelligence/finished/issue/${issueId}`} />}

      {rawQuery.isSuccess && <Navigate to={`/intelligence/raw/issue/${issueId}`} />}
    </ErrorWrapper>
  );
};

export default CommonIssue;
